"use client";

import Link from "next/link";
export function NeedBrokerSection() {
  return (
    <section className="section-padding relative overflow-hidden">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute inset-0 bg-[linear-gradient(180deg,#FFFFFF_0%,#F8FAFC_44%,theme-green-soft_100%)]" />
        <div className="absolute -left-20 top-10 h-56 w-56 rounded-full bg-[radial-gradient(circle,rgba(41,98,255,0.08),rgba(255,255,255,0)_72%)] blur-2xl" />
        <div className="absolute -right-16 bottom-8 h-56 w-56 rounded-full bg-[radial-gradient(circle,rgba(0,200,83,0.08),rgba(255,255,255,0)_74%)] blur-2xl" />
        <div
          className="absolute inset-0 opacity-[0.12]"
          style={{
            backgroundImage:
              "linear-gradient(to right, rgba(10,10,10,0.08) 1px, transparent 1px), linear-gradient(to bottom, rgba(10,10,10,0.08) 1px, transparent 1px)",
            backgroundSize: "46px 46px",
            maskImage:
              "radial-gradient(ellipse at center, black 30%, rgba(0,0,0,0.48) 62%, transparent 100%)",
            WebkitMaskImage:
              "radial-gradient(ellipse at center, black 30%, rgba(0,0,0,0.48) 62%, transparent 100%)",
          }}
        />
      </div>

      <div className="container relative mx-auto flex flex-col gap-7 md:gap-8">
        <div className="mx-auto max-w-[860px] text-center">
          <h2 className="text-section-h1">Do I need a broker?</h2>
          <p className="mt-2 text-sm text-muted-foreground md:text-base">
            It depends on your timeline, deal complexity, and how hands-on you
            want to be.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <article className="group relative rounded-2xl border border-theme-blue/20 bg-card/92 p-6 shadow-[0_10px_24px_rgba(0,0,0,0.05)] transition-all hover:-translate-y-0.5 hover:shadow-[0_14px_30px_rgba(41,98,255,0.12)]">
            <div className="pointer-events-none absolute inset-y-0 left-0 w-1 rounded-l-2xl bg-theme-blue/70" />
            <h3 className="text-section-h3">Consider going it alone if:</h3>
            <ul className="mt-4 flex flex-col gap-3 text-sm text-muted-foreground md:text-base">
              <li className="flex gap-2 rounded-lg border border-border/70 bg-card px-3 py-2 transition-colors hover:border-theme-blue/25 hover:text-foreground">
                <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-theme-blue" />
                Your business is straightforward
              </li>
              <li className="flex gap-2 rounded-lg border border-border/70 bg-card px-3 py-2 transition-colors hover:border-theme-blue/25 hover:text-foreground">
                <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-theme-blue" />
                You already know a potential buyer
              </li>
              <li className="flex gap-2 rounded-lg border border-border/70 bg-card px-3 py-2 transition-colors hover:border-theme-blue/25 hover:text-foreground">
                <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-theme-blue" />
                You are comfortable negotiating directly
              </li>
            </ul>
          </article>

          <article className="group relative rounded-2xl border border-success/22 bg-card/92 p-6 shadow-[0_10px_24px_rgba(0,0,0,0.05)] transition-all hover:-translate-y-0.5 hover:shadow-[0_14px_30px_rgba(0,200,83,0.12)]">
            <div className="pointer-events-none absolute inset-y-0 left-0 w-1 rounded-l-2xl bg-success/75" />
            <h3 className="text-section-h3">Consider working with a broker if:</h3>
            <ul className="mt-4 flex flex-col gap-3 text-sm text-muted-foreground md:text-base">
              <li className="flex gap-2 rounded-lg border border-border/70 bg-card px-3 py-2 transition-colors hover:border-success/25 hover:text-foreground">
                <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-success" />
                You want expert help setting price and positioning
              </li>
              <li className="flex gap-2 rounded-lg border border-border/70 bg-card px-3 py-2 transition-colors hover:border-success/25 hover:text-foreground">
                <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-success" />
                You want access to a wider buyer pool
              </li>
              <li className="flex gap-2 rounded-lg border border-border/70 bg-card px-3 py-2 transition-colors hover:border-success/25 hover:text-foreground">
                <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-success" />
                You prefer staying focused on operations while selling
              </li>
              <li className="flex gap-2 rounded-lg border border-border/70 bg-card px-3 py-2 transition-colors hover:border-success/25 hover:text-foreground">
                <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-success" />
                You want support through diligence and negotiations
              </li>
            </ul>
          </article>
        </div>

        <div className="mx-auto max-w-[900px] rounded-xl border border-border bg-card/92 px-5 py-4 text-center text-sm text-muted-foreground shadow-[0_8px_18px_rgba(0,0,0,0.04)] md:text-base">
          You can start free either way. Browse brokers now, and switch paths later
          as your sale strategy evolves.
          <span className="ml-1 inline">
            <Link href="/business-brokers" className="text-theme-blue hover:underline">
              Explore brokers
            </Link>
            .
          </span>
        </div>
      </div>
    </section>
  );
}
